import { AuthManager } from "../../component/auth/AuthContext";
import * as React from "react";
import { Component } from "react";
import { RouteComponentProps } from "react-router";
import EvalWorkflowApi, { EvalWorkflow } from "../../api/EvalWorkflowApi";
import { Button } from "reactstrap";
import MessageService from "../../service/MessageService";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

interface GroundTruthWelcomeProps extends RouteComponentProps {
  authManager: AuthManager;
}

interface GroundTruthWelcomeState {
  evalCode?: string;
}

export default class GroundTruthWelcome extends Component<GroundTruthWelcomeProps, GroundTruthWelcomeState> {
  private evalWorkflowApi: EvalWorkflowApi;

  constructor(props: GroundTruthWelcomeProps) {
    super(props);
    this.evalWorkflowApi = EvalWorkflowApi.with(this.props.authManager.cancelableClient());
    this.state = {};
  }

  componentDidMount(): void {
    this.evalWorkflowApi.findEval(EvalWorkflow.GT).then((evaluation) => {
      if (evaluation) {
        this.setState({ evalCode: evaluation.code });
      } else {
        const { t } = useTranslation();
        MessageService.info("GT.noEval");
      }
    });
  }

  render() {
    return (
      <div className="container">
        <h1>{i18n.t("GT.title")}</h1>

        <Button onClick={() => this.startWorkflow()} disabled={!this.state.evalCode}>
          {i18n.t("GT.start")}
        </Button>
      </div>
    );
  }

  private startWorkflow() {
    const params = new URLSearchParams();
    params.append("evalCode", this.state.evalCode);
    const paramsStr = params.toString();

    this.props.history.push("/ground-truth-workflow?" + paramsStr);
  }
}
